import styled from 'styled-components';

const Wrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: ${(props) => (props.narrow ? '16px' : '0')} 16px 16px;
  border-top: ${(props) => props.narrow ? '1px solid rgba(0, 0, 0, 0.08)' : 'none'};
`;

export { Wrapper };
